import { B2gContract } from '@/dto/B2g/B2gContract'
import type Controller from './Controller'
import { makeAdapter } from './Adapter'
import contractApi from '@/api/contractApi'

class ContractController implements Controller {
  adapter = makeAdapter({
    from(data: res.B2gContract): B2gContract {
      return new B2gContract(data)
    },
  })
  // crm에서 전송한 계약서 정보
  async fetchContractInfo() {
    const {
      data: { data },
    } = await contractApi.getContractInfo()
    return this.adapter.from(data)
  }
  // 계약서 제출
  async submitContract(data: req.B2gSignature) {
    return await contractApi.postContract(data)
  }
  // 계약서 다운로드
  async downloadContractPdf() {
    const {
      data: { data },
    } = await contractApi.downloadContractPdf()
    return data
  }
}
export const contractController = new ContractController()
